<template>
    <div class="select">
        <v-icon name="arrow-dropdown" />
        <select @input="$emit('input', $event.target.value)">
            <option v-for="(option, inx) in options"
                    :key="inx"
                    :value="option.key">{{ option.value }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss">
.select {
    position: relative;
    width: 100%;
    background-color: #ffffff;
    svg {
        position: absolute;
        z-index: 1;
        top: 50%;
        right: 0.5rem;
        transform: translateY(-50%);
        height: 20px;
        width: 20px;
        fill: #c9d700;
    }
    select {
        position: relative;
        z-index: 2;
        padding-left: 0.5rem;
        padding-right: calc(20px + 1rem);
        background-color: transparent;
    }
}
</style>
